import React, { useEffect, useRef, useState } from "react";
import "./../HomePage/HomePage.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import r, { api } from "../../modules/Request";
import {
  UPDATE_USER_STATUS,
  SET_USER_STATUS,
  UPDATE_MESSAGE,
} from "../../constants/system";

export default function Header({ resAll, visitH5Data, setVisitH5Data }) {
  const language = useSelector((state) => state.language);
  const messageRedux = useSelector((state) => state.message);
  const [visibleEn, setvisibleEn] = useState("1");
  const dispatch = useDispatch();
  const history = useHistory();
  const { id, type, languageStatus } = r.getQueryString();
  /* const dataCenterUrl = ['/dataCenter','/productDetail','/productDetail']
  const getPathname = window.location.pathname; */
  // 访问次数
  const visitH5Fn = async () => {
    try {
      let res = await r.post(api.VISIT_H5 + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        setVisitH5Data(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 中英文
  const filterLngFn = async () => {
    try {
      let res = await r.get(api.FOOT_FILTER_LNG + id);
      if (res.status.code === "00000") {
        let { filterLngFlag, lngFlag } = res?.data;
        /* let {filterLngFlag,lngFlag} = {
                    "filterLngFlag": 1,
                    "lngFlag": 2
                }; */
        if (lngFlag === 1 || messageRedux.switchEn === "") {
          dispatch({
            type: UPDATE_USER_STATUS,
            payload: filterLngFlag === 1 ? true : false,
          });
        }

        dispatch({
          type: UPDATE_MESSAGE,
          payload: {
            messageCount: lngFlag,
            getMsg: true,
          },
        });
        // setVisitH5Data(filterLngFlag === 1 ? true : false);
        setvisibleEn(lngFlag);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // redux切换
  /*const lenSwitc = async () => {
    setVisitH5Data((e) => !e);
  };*/
  const lenSwitc = async () => {
    dispatch({
      type: UPDATE_USER_STATUS,
      payload: !language,
    });
    dispatch({
      type: UPDATE_MESSAGE,
      payload: {
        switchEn: !language,
      },
    });
  };
  useEffect(() => {
    // if(window.location.pathname!='/emissionReduction'){
    visitH5Fn();
    // }
    filterLngFn();
    /* if(!messageRedux.getMsg){
    } */
  }, []);
  useEffect(() => {
    console.log(messageRedux);
  }, [messageRedux]);

  return (
    <>
      <div className="app-content-top">
        <img src={resAll?.entLogo} alt="" />
        {messageRedux.messageCount === 2 && (
          <div className="button-box">
            <p
              className={language ? "checked" : " "}
              onClick={() => {
                lenSwitc();
              }}
            >
              中
            </p>
            <p
              className={!language ? "checked" : " "}
              onClick={() => {
                lenSwitc();
              }}
            >
              En
            </p>
          </div>
        )}
      </div>
    </>
  );
}
